import { useMutation } from '@tanstack/react-query';
import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { CampaignResponse } from 'clients/CampaignsClient/CampaignsClient.types';
import { useContext } from 'react';
import { setCampaign } from 'shared/legacy/contexts/CampaignManagerContext/CampaignManagerContext.useCampaign';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useCreateSnackbar } from 'shared/legacy/contexts/SnackbarContext/useCreateSnackbar';

export type UseCampaignSaveMutationParams = {
  campaignId?: number;
  data: Partial<CampaignResponse>;
};

export const useCampaignSaveMutation = () => {
  const { dictionary } = useContext(LocalizationContext);
  const createSnackbar = useCreateSnackbar();

  return useMutation(
    async ({ campaignId, data }: UseCampaignSaveMutationParams) => {
      if (campaignId) {
        const { data: response } = await campaignsClient.updateCampaign(campaignId, data);

        return response;
      }

      const { data: response } = await campaignsClient.createCampaign(data);

      return response;
    },
    {
      onSuccess: (updatedCampaign, { campaignId }) => {
        if (campaignId) {
          createSnackbar(dictionary.saved);
          setCampaign(updatedCampaign.id, () => updatedCampaign);
        }
      },
      onError: () => {
        createSnackbar(dictionary.error, { variant: 'danger' });
      },
    },
  );
};
